<script setup>
import {computed} from 'vue'
import SiteTreePageItem from './SiteTreePageItem'
import {useTemplatesStore} from '@/stores/templates'
import {useSiteTreeStore} from '@/stores/siteTree'

const props = defineProps({
    siteTreeId: String
})

const templatesStore = useTemplatesStore()
const siteTreeStore = useSiteTreeStore(props.siteTreeId)

templatesStore.init()

const groupedPageIds = computed(() => {
    return siteTreeStore.groupedPageIds
})

const selectedNavigationGroup = computed(() => {
    return siteTreeStore.selectedNavigationGroup
})
</script>

<template>
    <template v-for="(pageIds, navigationGroup) in groupedPageIds" :key="navigationGroup">
        <div v-if="navigationGroup === selectedNavigationGroup" class="list-group list-group-flush small">
            <SiteTreePageItem v-for="pageId in pageIds" :key="pageId" :page-id="pageId" :site-tree-id="siteTreeId"/>
        </div>
    </template>
</template>